import { IRecruiterDashboardSettings } from '../../../hooks/useRecruiterDashboardSettings';
import { calculateWorkingDays } from '../../../utils/workingDaysCalculator';
import { getStatusFromBreakpoints } from '../../cards/DataStripStacked';

interface IPeriodGoalStats {
  workingDaysCount: number;
  workingDaysLeftCount: number;
  workingDaysElapsed: number;
  goal: number;
  pacePercent: number;
  status: ReturnType<typeof getStatusFromBreakpoints> | null;
  isPeriodClosed: boolean;
}

export function computePeriodGoalStats(
  periodStart: Date,
  fullPeriodEnd: Date,
  settings: IRecruiterDashboardSettings | null,
  totalUnits: number,
  dailyGoal: number
): IPeriodGoalStats {
  if (!settings) {
    return {
      workingDaysCount: 0,
      workingDaysLeftCount: 0,
      workingDaysElapsed: 0,
      goal: 0,
      pacePercent: 0,
      status: null,
      isPeriodClosed: false,
    };
  }
  const workingDaysCount = calculateWorkingDays(
    periodStart,
    fullPeriodEnd,
    settings.workingDays,
    settings.excludedDates
  );
  const today = new Date();
  const workingDaysLeftCount =
    today < periodStart
      ? workingDaysCount
      : today > fullPeriodEnd
      ? 0
      : calculateWorkingDays(
          today,
          fullPeriodEnd,
          settings.workingDays,
          settings.excludedDates
        );
  const workingDaysElapsed = workingDaysCount - workingDaysLeftCount;
  const goal = workingDaysCount * dailyGoal;
  const isPeriodClosed = fullPeriodEnd < new Date();
  const effectiveElapsed =
    workingDaysElapsed <= 0 && totalUnits > 0 ? 1 : workingDaysElapsed;
  const pacePercent =
    effectiveElapsed > 0 && dailyGoal > 0
      ? Math.round((totalUnits / effectiveElapsed / dailyGoal) * 100)
      : 0;
  const status = getStatusFromBreakpoints(pacePercent, {
    thresholds: settings.statusBreakpoints,
    labels: settings.statusLabels,
  });
  return {
    workingDaysCount,
    workingDaysLeftCount,
    workingDaysElapsed,
    goal,
    pacePercent,
    status,
    isPeriodClosed,
  };
}
